
define(
	'Tavano.TavanoteamGA4.TTGA4'
	, [
		'Tavano.TavanoteamGA4.TTGA4.Shopping'
		, 'Tavano.TavanoteamGA4.TTGA4.MyAccount'
		, 'Tavano.TavanoteamGA4.TTGA4.Checkout'
	]
	, function (
		TTGA4Shopping
		, TTGA4MyAccount
		, TTGA4Checkout
	) {
		'use strict';
		return {
			mountToApp: function mountToApp(container) {
				if (SC.ENVIRONMENT.SCTouchpoint == 'shopping') {
					TTGA4Shopping.loadGA4Shopping(container);
				}
				else if (SC.ENVIRONMENT.SCTouchpoint == 'myaccount') {
					TTGA4MyAccount.loadGA4MyAccount(container);
				}
				else if (SC.ENVIRONMENT.SCTouchpoint == 'checkout') {
					TTGA4Checkout.loadGA4Checkout(container);
				}
			}
		};
	});
